export default "__VITE_ASSET__BSfrZdGJ__"